<template>
  <div class="register">
    <div class="wrapper">
      <div class="dialog dialog-shadow" style="display: block; margin-top: -362px;">
        <div class="title">
        </div>
        <div class="content">
          <ul class="common-form">
            <li>
              <div class="input">
                <input type="phone" v-model="registered.userName" placeholder="手机号码"
                  @keyup="registered.userName = registered.userName.replace(/[^\w\.\/]/ig,'')">
              </div>
            </li>
            <li>
              <div class="input">
                <input type="password" v-model="registered.userPwd" placeholder="登录密码">
              </div>
            </li>
            <li>
              <div class="input">
                <input type="password" v-model="registered.userPwd2" placeholder="重复密码">
              </div>
            </li>
            <li>
              <div class="input-sms">
                <input type="number" v-model="registered.smsCode" placeholder="短信验证码" :disabled="!smsFlag">
                <y-button
                  :classStyle="registered.userName.length === 11 && !smsFlag && smstxt === '获取验证码'?'main-btn':'disabled-btn'"
                  :text="smstxt" style="margin:0;width: 35%;" @btnClick="snedSmsCode">
                </y-button>
              </div>
            </li>
          </ul>
          <el-checkbox class="agree" v-model="agreement">
            我已阅读并同意遵守
            <!-- <a @click.prevent="openAgree('00')">用户注册条款</a> 和 -->
            <a @click.prevent="openAgree('01')">网站免责声明</a>
          </el-checkbox>

          <div style="margin: 20px 0;">
            <y-button
              :classStyle="registered.userPwd && registered.userPwd2 && registered.userName && registered.smsCode && registxt === '注册'?'main-btn':'disabled-btn'"
              :text="registxt" style="margin: 0;width: 100%;height: 48px;font-size: 18px;line-height: 48px"
              @btnClick="register">
            </y-button>
          </div>

          <div class="border" style="margin-bottom: 10px;"></div>

          <ul class="common-form pr">
            <!-- <li class="pa" style="left: 0;top: 0;margin: 0;color: #d44d44">{{registered.errMsg}}</li> -->
            <li style="text-align: center;line-height: 48px;margin-bottom: 0;font-size: 12px;color: #999;width: 100%;">
              <span>如果您已拥有账号，</span>
              <a href="javascript:;" style="margin-right: 20px" @click="toLogin">立即登陆</a>
              <span>|</span>
              <span style="margin-left: 20px">
                <span>无法接收验证码，</span>
                <a href="javascript:;" @click="toCustom">联系客服</a>
              </span>
            </li>
          </ul>
        </div>

      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :center="true" width="60%" top="8vh">
      <div class="dialog-content">
        <div v-html="dialogContent"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeAgree()">我已阅读</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
  import YButton from '/components/YButton'
  import {
    register,
    userAgree
  } from '/api/index.js'
  export default {
    data() {
      return {
        registered: {
          userName: '',
          userPwd: '',
          userPwd2: '',
          smsCode: '',
          errMsg: ''
        },
        agreement: false,
        registxt: '注册',
        smstxt: '获取验证码',
        smsFlag: false,
        dialogVisible: false,
        dialogTitle: '',
        dialogContent: ''
      }
    },
    computed: {
      count() {
        return this.$store.state.isLogin
      }
    },
    methods: {
      openAgree(agreeType) {
        if (agreeType === '00') {
          this.dialogTitle = '用户注册条款';
        } else if (agreeType === '01') {
          this.dialogTitle = '网站免责声明';
        }
        this.$api.get({
          url: '/biz/agree/' + agreeType
        }).then(res=>{
          if (res.code === 200) {
            this.dialogContent = this.$yxz.showHtml(res.data.agreeContent) || '';
            this.dialogTitle = res.data.agreeTitle || ''
            this.dialogVisible = true;
          }
        })
      },
      closeAgree() {
        this.dialogTitle = '';
        this.dialogContent = '';
        this.dialogVisible = false;
      },
      snedSmsCode() {
        this.$api.get({
            url: '/common/sendSMS',
            data:{
              mobile:this.registered.userName
            }
        }).then(res=>{
          if(res.code==200) {
            this.$yxz.msg('验证码发送成功','success');
            this.smsFlag = true
          }
        })
      },
      open(t, m) {
        this.$notify.info({
          title: t,
          message: m
        })
      },
      message(m) {
        this.$message.error({
          message: m
        })
      },
      toLogin() {
        this.$yxz.to('/login')
      },
      toCustom(){
        const route = this.$router.resolve({ path: '/contact' });
        window.open(route.href, '_blank');
      },
      register() {
        this.registxt = '注册中...'
        let userName = this.registered.userName
        let userPwd = this.registered.userPwd
        let userPwd2 = this.registered.userPwd2
        let smsCode = this.registered.smsCode
        if (!userName || !userPwd || !userPwd2) {
          this.$yxz.msg('账号密码不能为空')
          this.registxt = '注册'
          return false
        }
        if(userPwd.length < 6) {
          this.$yxz.msg('密码至少6位')
          this.registxt = '注册'
          return false
        }
        if (userPwd2 !== userPwd) {
          this.$yxz.msg('两次输入的密码不相同')
          this.registxt = '注册'
          return false
        }
        if (!this.agreement) {
          this.$yxz.msg('请阅读并同意相关注册协议')
          this.registxt = '注册'
          return false
        }
        if (!smsCode) {
          this.$yxz.msg('短信验证码不能为空')
          this.registxt = '注册'
          return false
        }
        this.$api.post({
          url:'/register',
          data: {
              loginName: userName,
              loginPassword: userPwd,
              smsCode: smsCode
          }
        }).then(res => {
          if (res.code == 200) {
             this.$yxz.msg('恭喜您在医小智注册成功，现在您可畅游医小智;','success')
             this.toLogin()
          } else {
            this.$yxz.msg(res.msg)
            this.registxt = '注册'
            return false
          }
        })
      }
    },
    mounted() {
      this.$yxz.title("医小智 - 注册")
    },
    components: {
      YButton
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  * {
    box-sizing: content-box;
  }
  .register {
    overflow-x: hidden;
    overflow-y: hidden;

    .input {
      width: 370px;
      height: 50px;
      display: flex;
      align-items: center;

      input {
        font-size: 16px;
        width: 100%;
        height: 100%;
        padding: 10px 15px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        border-radius: 6px;
      }
    }

    .input-sms {
      height: 50px;
      display: flex;
      align-items: center;

      input {
        font-size: 16px;
        width: 100%;
        height: 100%;
        padding: 10px 15px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        border-radius: 6px;
        margin-right: 10px;
      }
    }

    .wrapper {
      background: url(/static/images/bg.png) repeat;
      background-size: 100px;
      min-height: 100%;
      min-width: 100%;
    }
  }

  .register .dialog {
    width: 450px;
    border: 1px solid #dadada;
    border-radius: 8px;
    top: 50%;
    left: 50%;
    margin-left: -225px;
    position: absolute;

    .title {
      background: linear-gradient(#fff, #f5f5f5);
      height: auto;
      overflow: visible;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
      position: relative;
      background-image: url(/static/images/bg_login.png);
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      height: 225px;
      box-shadow: none;
      border-radius: 8px 8px 0px 0px;
      margin-bottom: 30px;
    }

    .content {
      padding: 0px 40px 30px;
      height: auto;

      .common-form {
        li {
          clear: both;
          margin-bottom: 15px;
          position: relative;
          width:350px;
        }
      }
    }
  }

  .register .dialog-shadow {
    -webkit-box-shadow: 0 9px 30px -6px rgba(0, 0, 0, 0.2),
      0 18px 20px -10px rgba(0, 0, 0, 0.04), 0 18px 20px -10px rgba(0, 0, 0, 0.04),
      0 10px 20px -10px rgba(0, 0, 0, 0.04);
    -moz-box-shadow: 0 9px 30px -6px rgba(0, 0, 0, 0.2),
      0 18px 20px -10px rgba(0, 0, 0, 0.04), 0 18px 20px -10px rgba(0, 0, 0, 0.04),
      0 10px 20px -10px rgba(0, 0, 0, 0.04);
    box-shadow: 0 9px 30px -6px rgba(0, 0, 0, 0.2),
      0 18px 20px -10px rgba(0, 0, 0, 0.04), 0 18px 20px -10px rgba(0, 0, 0, 0.04),
      0 10px 20px -10px rgba(0, 0, 0, 0.04);
  }

  .border {
    margin-top: 10px;
    border-bottom: 1px solid #ccc;
  }

  .dialog-content {
    height: 55vh;
    overflow: auto;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// register.vue?dba2c1fc